import { infoService } from './components/info-tip-service'
// import { initPartnersForm } from './components/form-service'
import { initFAQ } from 'components/faq'

infoService()
// initPartnersForm()
initFAQ()
